/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Form, Button } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import { useUser } from '../../contexts/AuthContext';
import useOrganisationDelete from '../../hooks/useOrganisationDelete';
import useAuthLogout from '../../hooks/useAuthLogout';

const propTypes = {
    className: PropTypes.string,
    fields: MicromagPropTypes.formFields,
    onUpdated: PropTypes.func,
};

const defaultProps = {
    fields: [],
    className: null,
    onUpdated: null,
};

const OrganisationDeleteForm = ({ fields, className, onUpdated }) => {
    const [open, setOpen] = useState();
    const url = useUrlGenerator();

    const user = useUser();
    const { logout } = useAuthLogout();
    const { delete: deleteOrganisation } = useOrganisationDelete();

    const postForm = useCallback(
        () =>
            deleteOrganisation().then(() => {
                logout();
            }),
        [logout, deleteOrganisation],
    );

    const openForm = useCallback(() => {
        setOpen(true);
    }, [setOpen]);

    return open ? (
        <>
            <FormattedMessage
                defaultMessage="Are you sure you want to delete your organisation?"
                description="Form message"
            />
            <Form
                action={url('organisation.destroy')}
                fields={fields}
                postForm={postForm}
                initialValue={user}
                submitButtonLabel={
                    <FormattedMessage
                        defaultMessage="I really want to delete my organisation"
                        description="Button label"
                    />
                }
                submitButtonTheme="danger"
                onComplete={onUpdated}
                className={className}
            />
        </>
    ) : (
        <Button className="btn btn-danger" onClick={openForm}>
            <FormattedMessage defaultMessage="Delete organisation" description="Button label" />
        </Button>
    );
};

OrganisationDeleteForm.propTypes = propTypes;
OrganisationDeleteForm.defaultProps = defaultProps;

export default OrganisationDeleteForm;
